export default [
  { to: 'employee_handbook', title: 'Employee Handbook' },
  { to: 'faq', title: 'FAQ' },
  { to: 'contact_info', title: 'Contact Information' },
  { to: 'events', title: 'Events' },
  { to: 'marketing', title: 'Marketing' },
  { to: 'tech_docs', title: 'Tech Documents' },
];
